<template>
  <div class="box" v-if="isShow">
    <p class="box-content">{{message}}</p>
  </div>
</template>
 
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    duration: {
      type: Number,
      default: 1000 //默认1000毫秒消失
    }
  },
  data() {
    return {
      isShow: false //是否显示标识
    };
  },
  methods: {
    show() {
      this.isShow = true;
      setTimeout(this.hide, this.duration);//设置时间自动消失
    },
    hide() {
      this.isShow = false;
      this.remove();//移除
    }
  }
};
</script>
 
<style>
.box {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box-content {
  min-width: 2rem;
  text-align: center;
  color: #fff;
  max-width: 5rem;
  background: rgba(0, 0, 0, .8);
  font-size: .28rem;  
  padding: .2rem .2rem;
  box-sizing: border-box;
  border-radius: .2rem;
}
</style>



// WEBPACK FOOTER //
// Alert.vue?de6c79ce